import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { DeleteReserTermAndCon, EditReserTermAndCon, ReserVoucherTermsAndCondi, SaveReserTermAndCon } from "../../Services/Service";


// ✅ Async Thunk
export const fetchTerms = createAsyncThunk(
    "terms/fetchTerms",
    async (propertyId) => {
        const response = await ReserVoucherTermsAndCondi(propertyId);
        return response;
    }
);

// ✅ Save Terms
export const saveTerms = createAsyncThunk(
    "terms/saveTerms",
    async (postData) => {
        const response = await SaveReserTermAndCon(postData);
        return response;
    }
);


export const deleteTerms = createAsyncThunk(
    "terms/deleteTerms",
    async (id) => {
        await DeleteReserTermAndCon(id);
        return id;
    }
);

export const updateTerms = createAsyncThunk(
    "terms/updateTerms",
    async (postData) => {
        const response = await EditReserTermAndCon(postData);
        return response;
    }
);

const termsSlice = createSlice({
    name: "terms",
    initialState: {
        termsList: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchTerms.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchTerms.fulfilled, (state, action) => {
                state.loading = false;
                state.termsList = action.payload;
            })
            .addCase(fetchTerms.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            // ✅ Save loader
            .addCase(saveTerms.pending, (state) => {
                state.loading = true;
            })
            .addCase(saveTerms.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(saveTerms.rejected, (state) => {
                state.loading = false;
            })

            // delete
            .addCase(deleteTerms.pending, (state) => {
                state.loading = true;
            })
            .addCase(deleteTerms.fulfilled, (state, action) => {
                state.loading = false;

                // ✅ Local state se remove
                state.termsList = state.termsList.filter(
                    item => item.ID !== action.payload
                );
            })
            .addCase(deleteTerms.rejected, (state) => {
                state.loading = false;
            })

            // update loader
            .addCase(updateTerms.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateTerms.fulfilled, (state, action) => {
                state.loading = false;

                const updatedItem = action.payload;

                const index = state.termsList.findIndex(
                    item => item.ID === updatedItem.ID
                );

                if (index !== -1) {
                    state.termsList[index] = updatedItem;
                }
            })
            .addCase(updateTerms.rejected, (state) => {
                state.loading = false;
            })
    },
});

export default termsSlice.reducer;